import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
	selector: 'pcm-dashboard-widget',
	templateUrl: './dashboard-widget.component.html',
	styleUrls: ['./dashboard-widget.component.scss']
})
export class DashboardWidgetComponent implements OnInit {

	@Input() title = '';
	@Input() path = '';
	@Input() prefix = '';
	@Input() suffix = '';
	@Input() count = 0;
	@Input() cleared = false;

	narrowSuffix = false;

	constructor(
		private router: Router
	) { }

	ngOnInit() {
		if (this.suffix.length < 30) {
			this.narrowSuffix = true;
		}
	}

	widgetClick(event) {
		this.router.navigateByUrl(this.path);
	}

	getCount() {
		if (isNaN(this.count)) {
			return "-";
		} else {
			return this.count;
		}
	}
}
